export function loadIdeasContent(ids, furtherParams, shopUserId, lazyLoadOnThisPage) {
    $.ajax({
        type: "POST",
        url: "/module/community/ajax.php?action=load_ideas_entries",
        datatype: "json",
        data: {
            "ajax_call_ids": ids,
            "ajax_call_list_community_type": communityType
        },
        success: function (output) {
            positionIdeasContents(output, lazyLoadOnThisPage);
            checkIfAlreadyProsted(ids, "", shopUserId, false, 8);
            checkIfAlreadyFavourites(ids, shopUserId, 8);
        }
    });
}